/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router';
import store from '@/store'
import {
  defaultPage
} from '@/assets/cannotAccessList';

import TokenMixin from '@/mixins/TokenMixin'
import Validator from '@/prototype/Validator'

Vue.use(VueRouter);
Vue.mixin(TokenMixin)
Vue.use(Validator)

const vm = new Vue();

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('toggleLoadingPage', false);
  store.dispatch('setLoading', false);
  window.scrollTo(0, 0);

  if (to.meta.requireAuth) {
    const userData = vm.getCurrentUserData();
    const isUserLogin = vm.$validate.DataValid(userData);

    if (isUserLogin) {
      if (to.meta.cannotAccess && to.meta.cannotAccess.includes(userData.user_type)) {
        next(defaultPage[userData.user_type])
      } else {
        next()
      }
    } else {
      if (to.meta.isCustomer) {
        next('/customer-login')
      } else {
        next('/login')
      }
    }
  } else if (to.meta.skipAuth) {
    const userData = vm.getCurrentUserData();
    if (vm.$validate.DataValid(userData) && userData.user_type) {
      if (to.name === 'login' || to.name === 'CustomerLogin' || to.meta.cannotAccess && to.meta.cannotAccess.includes(userData.user_type)) {
        next(defaultPage[userData.user_type]);
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    let store = `${process.env.VUE_APP_NAME} CMS`;
    if (to.meta.isCustomer) {
      store = process.env.VUE_APP_NAME;
    }
    to.meta.storeName = store;
    document.title = (`${to.meta.title} - ` || '') + store
  })
})

export default router
